var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":_vm.logout}},[_c('v-list-item-avatar',[_c('font-awesome-icon',{attrs:{"icon":['fal', 'sign-out']}})],1),_c('v-list-item-content',[_vm._v("ログアウト")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }